





































































import { Component, Vue } from "vue-property-decorator";
import AdvancedKanban from "@/components/Kanban/AdvancedKanban.vue";

@Component({
  name: "KanbanDemo",
  components: { AdvancedKanban },
})
export default class KanbanDemo extends Vue {
  selectedExample = "tasks";
  snackbar = false;
  snackbarText = "";
  snackbarColor = "success";

  examples: any = {
    tasks: {
      title: "Gestión de Tareas",
      columns: [
        {
          id: "todo",
          title: "Por Hacer",
          color: "#FF5722",
          icon: "mdi-clipboard-list",
        },
        {
          id: "progress",
          title: "En Progreso",
          color: "#FFC107",
          icon: "mdi-progress-clock",
        },
        {
          id: "done",
          title: "Completado",
          color: "#009688",
          icon: "mdi-check-circle",
        },
      ],
      items: [
        {
          id: "1",
          columnId: "todo",
          title: "Diseñar interfaz",
          description: "Mockups dashboard",
        },
        {
          id: "2",
          columnId: "progress",
          title: "Implementar login",
          description: "Sistema JWT",
        },
        {
          id: "3",
          columnId: "done",
          title: "Setup proyecto",
          description: "Config inicial",
        },
      ],
    },
    sales: {
      title: "Pipeline de Ventas",
      columns: [
        { id: "lead", title: "Lead", color: "#9C27B0" },
        { id: "qualified", title: "Calificado", color: "#2196F3" },
        { id: "proposal", title: "Propuesta", color: "#FF9800" },
        { id: "won", title: "Ganado", color: "#4CAF50" },
      ],
      items: [
        {
          id: "1",
          columnId: "lead",
          title: "Tech Solutions SA",
          description: "$50,000",
        },
        {
          id: "2",
          columnId: "qualified",
          title: "Global Systems",
          description: "$75,000",
        },
        {
          id: "3",
          columnId: "won",
          title: "StartupXYZ",
          description: "$45,000",
        },
      ],
    },
    projects: {
      title: "Gestión de Proyectos",
      columns: [
        { id: "backlog", title: "Backlog", color: "#607D8B" },
        { id: "dev", title: "En Desarrollo", color: "#3F51B5" },
        { id: "testing", title: "Testing", color: "#FF9800" },
        { id: "done", title: "Completado", color: "#4CAF50" },
      ],
      items: [
        {
          id: "1",
          columnId: "backlog",
          title: "Módulo Reportes",
          description: "Sistema PDF",
        },
        {
          id: "2",
          columnId: "dev",
          title: "Dashboard Analytics",
          description: "Gráficos",
        },
        {
          id: "3",
          columnId: "done",
          title: "Sistema Login",
          description: "JWT OK",
        },
      ],
    },
    support: {
      title: "Soporte Técnico",
      columns: [
        { id: "new", title: "Nuevo", color: "#E91E63" },
        { id: "assigned", title: "Asignado", color: "#9C27B0" },
        { id: "progress", title: "En Proceso", color: "#2196F3" },
        { id: "resolved", title: "Resuelto", color: "#4CAF50" },
      ],
      items: [
        {
          id: "1",
          columnId: "new",
          title: "Error login #1001",
          description: "Empresa XYZ",
        },
        {
          id: "2",
          columnId: "assigned",
          title: "Lentitud #1003",
          description: "Corp 123",
        },
        {
          id: "3",
          columnId: "resolved",
          title: "Reset password #1005",
          description: "Usuario Final",
        },
      ],
    },
  };

  get getCurrentColumns() {
    return this.examples[this.selectedExample].columns;
  }

  get getCurrentItems() {
    return this.examples[this.selectedExample].items;
  }

  get getCurrentTitle() {
    return this.examples[this.selectedExample].title;
  }

  handleItemMove(data: any) {
    this.showSnackbar(`Item movido a ${data.toColumnId}`, "success");
  }

  handleItemClick(item: any) {
    this.showSnackbar(`Click en: ${item.title}`, "info");
  }

  showSnackbar(text: string, color: string) {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }
}
